import { ref, Ref } from 'vue'

interface UseErrorStateResult {
  hasError: Ref<boolean>
  onError: () => void
}

export const useErrorState = (): UseErrorStateResult => {
  const hasError = ref(false)
  const onError = (): void => {
    hasError.value = true
  }
  return { hasError, onError }
}
